import Vue from 'vue'
import Router from 'vue-router'
import Splash from '@/components/Splash'
import Imprint from '@/components/Imprint'
import Privacy from '@/components/Privacy'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'Splash',
			component: Splash
		},
		{
			path: '/impressum',
			name: 'Imprint',
			component: Imprint
		},
		{
			path: '/datenschutz',
			name: 'Privacy',
			component: Privacy
		}
	]
})



// WEBPACK FOOTER //
// ./src/router.js